import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

import { Modal } from "./Modal";

import { HeaderModal } from "./Header";
import { Body } from "./Body";
import { FooterModal } from "./Footer";

import closeIcon from "assets/images/close-icon.svg";
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import allImgPaths from "assets/images";
import useAppState from "context/useAppState";
import CustomCheckBox from "components/CustomCheckBox";
import { cloneDeep } from "lodash";
import { generatePresignedUrl, uploadFileToS3 } from "services/auth/auth";
import { changeEventImage } from "services/event";
import Toast from "../Toast";

const ChangeFeteImgModal = ({ isShow, setIsShow }: any) => {
  const { setState: setEventDataState, showImageUploader, eventFetchedData, sampleImages } = useAppState("eventData");
  const [manageImg, setManageImg] = useState('sampleImg');
  const [imageData, setImageData] = useState<any>([])
  const userData = JSON.parse(localStorage.getItem('userData') as string)
  const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)
  const [selectedFile, setSelectedFile] = useState<any>(null)
  const [isUploading, setIsUploading] = useState(false)

  useEffect(() => {
    setImageData(sampleImages || [])
  }, [sampleImages])

  const handleImages = (imgType: string) => {
    setManageImg(imgType);
  }

  const onCloseModal = () => {
    setEventDataState({ showImageUploader: false })
  }

  const handleImageSelection = (index: any, isChecked?: boolean) => {
    let clonedData = cloneDeep(imageData);
    clonedData = clonedData.map((cd: any, cInd: number) => {
      // cd['selected'] = index == cInd ? isChecked : false;
      cd['selected'] = index == cInd ? true : false;
      return cd
    })
    setImageData(clonedData)
  }

  const changeImage = async (from: any) => {
    if (manageImg == 'customImg') {
      if (!selectedFile) return
      setIsUploading(true)
      await uploadCustomImageHandler()
    } else {
      const image = imageData.find((id: any) => id.selected);
      if (!image) return

      setIsUploading(true)
      // console.log({ image })
      const payload = {
        event_id: eventFetchedData._id,
        file_name: image.key,
        content_type: `image/${image.key.split('.').pop()}`,
        upload_type: manageImg
      }
      await updateFeteImageAPI(payload)
    }
  }

  const uploadCustomImageHandler = async () => {
    const preSignedPayload = {
      file_name: selectedFile.name,
      content_type: selectedFile.type,
      category: 'document'
    }

    const preSigedURLObj = await getPresignedURL(preSignedPayload)

    if (preSigedURLObj) {
      const response = await initiateS3UploadWithPresignedURL(preSigedURLObj)
      if (response?.status == 200) {
        const payload = {
          event_id: eventFetchedData._id,
          file_name: preSigedURLObj.fileName,
          content_type: selectedFile.type,
          upload_type: manageImg
        }
        await updateFeteImageAPI(payload)
      }
    }
  }

  // Get The Pre-Signed URL
  const getPresignedURL = async (file: any) => {
    try {
      const { data } = await generatePresignedUrl({
        ...file,
        event_id: eventFetchedData._id,
        user_id: userData?.id,
        team_id: currentTeam?.currentTeamId
      });
      return data;
    } catch (error) {
      // console.log({ preSignedGenErr: error });
      Toast.error('File upload failed', 'Please try after sometime')
      return null
    }
  }

  // Upload To S3 With The Pre-Signed URL
  const initiateS3UploadWithPresignedURL = async (presigedURLObj: any) => {
    try {
      const response = await uploadFileToS3({
        url: presigedURLObj.url, file: selectedFile, type: selectedFile.type
      })

      return response;
    } catch (error) {
      Toast.error('File upload failed', 'Please try after sometime')
      // console.log({ fileUploadError: error })
      return null
    }
  }

  // Update The Fete Data In DB
  const updateFeteImageAPI = async (payload: any) => {
    try {
      const { data } = await changeEventImage(payload);

      setIsUploading(false)
      setSelectedFile(null)
      setEventDataState({ showImageUploader: false, updatedFeteImageUrl: data })
    } catch (error) {
      Toast.error('File upload failed', 'Please try after sometime')
      // console.log({ updateImageError: error })
    }
  }

  const handleChange = (file: any) => {
    const maxSizeInMB = 5;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    if (file) {
      if (file.size > maxSizeInBytes) {
        Toast.warning('', `File size exceeds ${maxSizeInMB} MB. Please select a smaller file.`);
        return;
      }

      setSelectedFile(file);
    }
  }

  const getFileSize = (sizeInBytes: any) => {
    if (sizeInBytes) {
      const sizeInKB = sizeInBytes / 1024;
      if (sizeInKB < 1024) {
        return sizeInKB.toFixed(2) + ' KB';
      } else {
        const sizeInMB = sizeInKB / 1024;
        return sizeInMB.toFixed(2) + ' MB';
      }
    }
    return null
  }

  return (
    <>
      <Modal className={"modal-wrapper max-w-[498px]"} isShow={isShow}>
        <form>
          <HeaderModal title={"test"} isShowHeader={true} className="modal-header pt-6 px-6 border-b border-[#EAECF0]p pb-5">
            <div className="flex items-center justify-between">
              <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                Change Fete Image
              </h2>
              {/* Close Icon */}
              <img
                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 -mt-2"
                id="modal-toggle"
                src={closeIcon}
                onClick={onCloseModal}
                alt="close icon"
              />
            </div>

            <p className="text-sm text-[#475467]">Select from the ones shown here or add your own</p>
          </HeaderModal>

          <Body title="" isShowBody={true} className="modal-body px-6 pt-5 pb-5">
            <div className="flex items-center gap-x-4 pb-2 border-b border-[#E4E7EC] mb-5">
              <button type="button" onClick={() => handleImages('sampleImg')} className={` font-interSemiBold py-2 px-3 rounded-lg hover:bg-[#E8E6FE] hover:text-[#1E0AF5] ${manageImg === 'sampleImg' ? "text-[#1E0AF5] bg-[#E8E6FE]" : "text-[#667085] bg-transparent"}`}>Fete Images</button>

              <button type="button" onClick={() => handleImages('customImg')} className={` font-interSemiBold py-2 px-3 rounded-lg hover:bg-[#E8E6FE] hover:text-[#1E0AF5] ${manageImg === 'customImg' ? "text-[#1E0AF5] bg-[#E8E6FE]" : "text-[#667085] bg-transparent"}`}>Upload Custom Image</button>
            </div>

            <div className="">
              {/* Sample image */}
              {
                manageImg === 'sampleImg' && (
                  <div className="flex flex-wrap gap-4 overflow-y-auto max-h-[338px] pr-2">
                    {
                      imageData.map((item: any, ind: any) => (
                        <div onClick={() => handleImageSelection(ind)} className={`border rounded hover:border-[#1E0AF5] cursor-pointer p-1 ${item.selected ? "border-[#1E0AF5]" : "border-[#E4E7EC]"}`} key={ind}>
                          {/* <span className='checkbox-alignment'>
                            <CustomCheckBox
                              name={item.url}
                              checked={item.selected}
                              onChange={(name: string, isChecked: boolean) => handleImageSelection(ind, isChecked)}
                              customStyle="hidden"
                            />
                          </span> */}
                          <img className="w-[200px] h-[92px] rounded object-cover" src={item.url} alt="" />
                        </div>
                      ))
                    }
                  </div>
                )
              }

              {/* Upload image */}
              {
                manageImg === 'customImg' && (
                  <>
                    <div className="">
                      <input
                        type="file"
                        id="actual-btn"
                        onChange={(e: any) => handleChange(e.target.files[0])}
                        hidden
                        accept=".svg, .png, .ppg, .gif"
                      />
                      <label className='file-upload block border border-[#EAECF0] hover:border-[#786CF9] rounded-xl py-4 px-6 text-center mb-6 cursor-pointer' htmlFor="actual-btn">
                        <img className='mb-3 mx-auto' src={allImgPaths.uploadFileIcon3} alt="" />
                        <div className="">
                          <span className='text-sm text-[#1E0AF5] font-interSemiBold'>Click to upload</span>
                          <span className='text-sm text-[#475467]'> or drag and drop</span>
                          <p className='text-sm text-[#475467]'>SVG, PNG, JPG or GIF (max. 800x400px)</p>
                        </div>
                      </label>
                    </div>

                    {
                      selectedFile &&
                      <div className="block border-2 border-[#EAECF0] rounded-xl py-3.5 px-3.5 cursor-pointer mb-5">
                        <div className="flex gap-x-3 items-start">
                          <img
                            src={allImgPaths.imageIcon}
                            alt=""
                          />
                          <div className="w-full">
                            <div className="w-full">
                              <p className="text-sm text-[#475467]">{selectedFile?.name}</p>
                            </div>
                            <p className="text-sm text-[#475467] mt-3">{getFileSize(selectedFile?.size) || ''}</p>
                            <div className="flex items-center gap-x-2" />
                          </div>
                        </div>
                      </div>
                    }
                  </>
                )
              }
            </div>
          </Body>

          <FooterModal title="" isShowFooter={true} className="modal-footer pt-5 px-6 pb-4 border-t border-[#EAECF0]">
            <div className="flex items-center gap-x-3 justify-end">
              <button
                onClick={onCloseModal}
                type="button"
                className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base hover:bg-[#F2F4F7] w-40">
                Cancel
              </button>
              <button
                className={`!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 w-40 ${isUploading ? 'button-disabled' : ''} `}
                type="button"
                disabled={isUploading}
                onClick={changeImage}
              >
                Change
              </button>
            </div>
          </FooterModal>
        </form>
      </Modal>
    </>
  );
}

export default ChangeFeteImgModal;
